import { useCallback, useState } from "react"

export type DemoFilter = "brackets" | "matchups" | "props" | "creators"

interface UseDemoCardsStateReturn {
  cfbExpanded: boolean
  nflExpanded: boolean
  mlbExpanded: boolean
  ncaabExpanded: boolean
  activeFilter: DemoFilter
  isAnyCardExpanded: boolean
  handleToggleCfb: () => void
  handleToggleNfl: () => void
  handleToggleMlb: () => void
  handleToggleNcaab: () => void
  handleFilterChange: (filter: DemoFilter) => void
}

export function useDemoCardsState(): UseDemoCardsStateReturn {
  const [cfbExpanded, setCfbExpanded] = useState(false)
  const [nflExpanded, setNflExpanded] = useState(true)
  const [mlbExpanded, setMlbExpanded] = useState(false)
  const [ncaabExpanded, setNcaabExpanded] = useState(false)
  const [activeFilter, setActiveFilter] = useState<DemoFilter>("brackets")

  const handleToggleCfb = useCallback(() => {
    setCfbExpanded((prev) => {
      const newValue = !prev
      if (newValue) {
        window.dispatchEvent(new Event("bracketCardExpanded"))
      }
      return newValue
    })
    if (!cfbExpanded) {
      setNflExpanded(false)
      setMlbExpanded(false)
      setNcaabExpanded(false)
    }
  }, [cfbExpanded])

  const handleToggleNfl = useCallback(() => {
    setNflExpanded((prev) => {
      const newValue = !prev
      if (newValue) {
        window.dispatchEvent(new Event("bracketCardExpanded"))
      }
      return newValue
    })
    if (!nflExpanded) {
      setCfbExpanded(false)
      setMlbExpanded(false)
      setNcaabExpanded(false)
    }
  }, [nflExpanded])

  const handleToggleMlb = useCallback(() => {
    setMlbExpanded((prev) => {
      const newValue = !prev
      if (newValue) {
        window.dispatchEvent(new Event("bracketCardExpanded"))
      }
      return newValue
    })
    if (!mlbExpanded) {
      setCfbExpanded(false)
      setNflExpanded(false)
      setNcaabExpanded(false)
    }
  }, [mlbExpanded])

  const handleToggleNcaab = useCallback(() => {
    setNcaabExpanded((prev) => {
      const newValue = !prev
      if (newValue) {
        window.dispatchEvent(new Event("bracketCardExpanded"))
      }
      return newValue
    })
    if (!ncaabExpanded) {
      setCfbExpanded(false)
      setNflExpanded(false)
      setMlbExpanded(false)
    }
  }, [ncaabExpanded])

  const handleFilterChange = useCallback((filter: DemoFilter) => {
    setActiveFilter(filter)
  }, [])

  const isAnyCardExpanded = cfbExpanded || nflExpanded || mlbExpanded || ncaabExpanded

  return {
    cfbExpanded,
    nflExpanded,
    mlbExpanded,
    ncaabExpanded,
    activeFilter,
    isAnyCardExpanded,
    handleToggleCfb,
    handleToggleNfl,
    handleToggleMlb,
    handleToggleNcaab,
    handleFilterChange,
  }
}
